import React from 'react';

const ExecutorsListPage: React.FC = () => {
  return (
    <div className="p-6">
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-2xl font-semibold text-gray-800">Исполнители</h1>
      </div>

      <div className="bg-white rounded-lg shadow p-10 text-center border border-gray-200">
        <p className="text-gray-500 text-lg">
          Раздел "Исполнители" находится в разработке.
        </p>
      </div>
    </div>
  );
};

export default ExecutorsListPage;